import React from 'react';
import { motion } from 'framer-motion';

export const Loader = () => {
    return (
        <motion.div
            className="fixed inset-0 z-[200] flex items-center justify-center bg-gray-100 bg-opacity-75 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            {/* Top progress bar */}
            <motion.div
                className="absolute top-0 left-0 h-1 bg-brand-accent"
                initial={{ width: '0%' }}
                animate={{ width: '100%' }}
                transition={{ duration: 1.9, ease: 'linear' }}
            />
            
            {/* Logo in the center with a pulse animation */}
            <motion.div
                className="relative"
                initial={{ opacity: 0 }}
                animate={{ 
                    opacity: 1,
                    scale: [1, 1.05, 1],
                    transition: {
                        duration: 2,
                        ease: "easeInOut",
                        repeat: Infinity,
                    }
                }}
            >
                {/* Ensure your logo is in the public folder */}
                <img src="/logo.png" alt="Community Portal Logo" className="w-24 h-24" />
            </motion.div>
        </motion.div>
    );
};

